module.exports = __webpack_public_path__ + "img/qq.5392896c.png";